var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaliciousIp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#6A686A",
    strokeWidth: 1.5,
    d: "M25 17.424c0-.455-.155-.838-.464-1.147-.309-.31-.676-.464-1.098-.464h-2.735v-2.881l2.295-2.246c.293-.325.44-.7.44-1.123 0-.423-.155-.79-.464-1.1-.31-.308-.676-.463-1.099-.463-.423 0-.798.147-1.123.44l-2.637 2.685H6.885L4.248 8.44c-.326-.293-.7-.44-1.123-.44-.423 0-.79.155-1.099.464-.309.31-.463.676-.463 1.099 0 .424.146.798.439 1.123l2.295 2.246v2.88H1.563c-.424 0-.79.156-1.099.465-.31.309-.464.692-.464 1.147 0 .424.163.78.488 1.074.325.293.7.44 1.123.44h2.686v.78c0 1.043.227 2.036.683 2.979l-2.978 2.93c-.293.326-.439.7-.439 1.123 0 .424.154.79.463 1.099.309.309.676.464 1.099.464.423 0 .797-.147 1.123-.44l2.637-2.685c1.302 1.042 2.783 1.562 4.443 1.562V14.836c0-.391.195-.586.586-.586h1.172c.391 0 .586.195.586.586V26.75c1.66 0 3.141-.52 4.443-1.562l2.637 2.685c.325.293.7.44 1.123.44.423 0 .789-.155 1.099-.464.309-.31.464-.675.464-1.1 0-.422-.147-.796-.44-1.122l-2.978-2.93c.455-.943.683-1.936.683-2.978v-.781h2.686c.423 0 .797-.147 1.123-.44.325-.293.488-.65.488-1.074z",
    transform: "translate(-72 -357) translate(72.938 358.386)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M23.5 17c4.694 0 8.5-3.806 8.5-8.5S28.194 0 23.5 0 15 3.806 15 8.5s3.806 8.5 8.5 8.5",
    transform: "translate(-72 -357) translate(72.938 358.386)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 1.5,
    d: "M23.5 17c4.694 0 8.5-3.806 8.5-8.5S28.194 0 23.5 0 15 3.806 15 8.5s3.806 8.5 8.5 8.5z",
    transform: "translate(-72 -357) translate(72.938 358.386)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#368FEF",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 10,
    fontWeight: "bold",
    transform: "translate(-72 -357) translate(72.938 358.386)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.313,
    y: 12.281
  }, "IP")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaliciousIp);
export default __webpack_public_path__ + "static/media/malicious_ip.8f8f3d0d9809857623d4977cea056fda.svg";
export { ForwardRef as ReactComponent };